module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "page-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "box-content text-center"
  }, [_c('h2', [_vm._v("TITAN PROMENADE TRIBUTE PROGRAM")]), _vm._v(" "), _c('div', {
    staticClass: "font-lg"
  }, [_c('p', [_vm._v("Make your mark at CSUF by April 30, 2022!")]), _vm._v(" "), _c('p', [_vm._v("\n                            Cal State Fullerton proudly invites you to etch your name in Titan history by securing a personalized paver, tree dedication or study nook naming on the new Titan Promenade. This iconic gateway leads from the south entrance of campus to the Pollak Library at heart of university with Titan pride of full display. The promenade includes incredible outdoor learning spaces with new furniture, beautiful landscaping, Wi-Fi towers and so much more. \n                        ")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\t\tEach paver or plaque can be inscribed with your personal message and will be installed along the Titan Promenade, paving the way for future students and visitors to campus. To be a part of history, place your order today! Honor a classmate, CSUF graduate, Titan sports fan, faculty or staff member. \n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\t\tMake your mark and support Cal State Fullerton!\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "red"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "/shop"
    }
  }, [_vm._v("ORDER NOW!")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('img', {
    staticClass: "about-img",
    attrs: {
      "src": "images/aboutlogo.png",
      "alt": "IT TAKES A TITAN"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('br'), _vm._v(" "), _c('i', [_vm._v("\n\t\t\t\t\t\t\t\tAll gifts support the It Takes a Titan campaign for Cal State Fullerton.\n\t\t\t\t\t\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78e79aee","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = KZgl
// module chunks = 1